import styled from '@emotion/styled';
import { mainColors, transactionHistoryTabColors } from 'src/assets/colors';

export const TableHeadRow = styled('tr', { label: 'TableHeadRow' })`
    border-bottom: none;
`;

export const TableTitleCell = styled('th', { label: 'TableTitleCell' })`
    font-size: 12px;
    color: #000;
`;

interface TableDataPropsType {
    amountNegative?: boolean;
}

export const TransactionHistoryTabContent = styled('div', { label: 'TransactionHistoryTabContent' })`
    min-height: 645px;
`;

export const TableData = styled('td', { label: 'TableData' }) <TableDataPropsType>`
    font-size: 12px;
    color: ${({ amountNegative }): string => amountNegative === true ? transactionHistoryTabColors.txtColorSecondary : transactionHistoryTabColors.txtColor};
`;

export const TableDataRow = styled('tr', { label: 'TableDataRow' })`
    border-bottom: none;
    cursor: pointer;
    &:nth-of-type(odd) {
        background-color: ${(): string => mainColors.extendedSecondary.secondary200};
    }
`;
